





























import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconLowChance extends Vue {
    @Prop({ type: Number, default: 24 }) readonly size!: number
}
